import type { ComponentType, FC } from 'react';
import dynamic from 'next/dynamic';
const ContinentPage = dynamic(() => import('@/templates/ContinentPage'));
const CountryPage = dynamic(() => import('@/templates/country/CountryPage'));
const CountryFactsPage = dynamic(() => import('@/templates/country/CountryFactsPage'));
const CountryTravelsPage = dynamic(() => import('@/templates/country/CountryTravelsPage'));
const CountryImagesPage = dynamic(() => import('@/templates/country/CountryImagesPage'));
const CountrySightsPage = dynamic(() => import('@/templates/country/CountrySightsPage'));
const CountryEntryPage = dynamic(() => import('@/templates/country/CountryEntryPage'));
const CountryVaccinationPage = dynamic(() => import('@/templates/country/CountryVaccinationPage'));
const CountryClimatePage = dynamic(() => import('@/templates/country/CountryClimatePage'));
const CountryMapPage = dynamic(() => import('@/templates/country/CountryMapPage'));
const CityPage = dynamic(() => import('@/templates/city/CityPage'));
const CityTripsPage = dynamic(() => import('@/templates/city/CityTripsPage'));
const CityFactsPage = dynamic(() => import('@/templates/city/CityFactsPage'));
const CityImagesPage = dynamic(() => import('@/templates/city/CityImagesPage'));
const CityClimatePage = dynamic(() => import('@/templates/city/CityClimatePage'));
const CityMapPage = dynamic(() => import('@/templates/city/CityMapPage'));
const CityVideosPage = dynamic(() => import('@/templates/city/CityVideosPage'));
const CountryVideosPage = dynamic(() => import('@/templates/country/CountryVideosPage'));
const StaticPage = dynamic(() => import('@/templates/StaticPage'));

export interface MagnoliaPagesMappingConfig {
  componentMappings: { [key: string]: FC<any> | ComponentType<any> };
}

export const pagesConfigDestinations: MagnoliaPagesMappingConfig = {
  componentMappings: {
    'website:pages/static': StaticPage,
    'website:pages/continent': ContinentPage,

    'website:pages/country': CountryPage,
    'website:pages/countryFacts': CountryFactsPage,
    'website:pages/countryTravels': CountryTravelsPage,
    'website:pages/countryImages': CountryImagesPage,
    'website:pages/countryVideos': CountryVideosPage,
    'website:pages/countrySights': CountrySightsPage,
    'website:pages/countryEntry': CountryEntryPage,
    'website:pages/countryVaccination': CountryVaccinationPage,
    'website:pages/countryClimate': CountryClimatePage,
    'website:pages/countryMap': CountryMapPage,

    'website:pages/city': CityPage,
    'website:pages/cityTrips': CityTripsPage,
    'website:pages/cityImages': CityImagesPage,
    'website:pages/cityVideos': CityVideosPage,
    'website:pages/cityFacts': CityFactsPage,
    'website:pages/cityClimate': CityClimatePage,
    'website:pages/cityMap': CityMapPage
  }
};
